<section [formGroup]="form" class="tipo-operacao">
  <h2 class="tipo-operacao__title">Tipo de Operação</h2>

  <div class="tipo-operacao__options">
    <app-button-selector
      *ngFor="let tipProd of tiposProduto"
      [data]="tipProd"
      [(selected)]="tipoProduto"
      (selectedChange)="onTipoProdutoChange($event)"></app-button-selector>
  </div>

  <div *ngIf="showProdutos" class="tipo-operacao">
    <h2 class="tipo-operacao__title">Produto</h2>
    <div class="tipo-operacao__options">
      <app-button-selector
        *ngFor="let prod of produtos"
        [data]="prod"
        [(selected)]="produto"
        (selectedChange)="onProdutoChange($event)">
    </app-button-selector>
    </div>
  </div>

  <div *ngIf="showBancos" class="tipo-operacao__options forms">
    <div class="form-group">
      <div class="inputs">
        <label for="seller-store">Banco</label>
        <select formControlName="banco" name="banco" class="form-control">
          <option value="" disabled>Selecione...</option>
          <option *ngFor="let banco of filterBancos" [value]="banco.codigo">{{ banco.codigo }} - {{ banco.descricao }}</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="showOperacoes" class="tipo-operacao__options forms">
    <div class="form-group">
      <div class="inputs">
        <label for="seller-store">Código da Operação</label>
        <select formControlName="operacao" name="codigosOperacoes" class="form-control">
          <option value="" disabled>Selecione...</option>
          <option *ngFor="let codigo of operacoes" [value]="codigo.id">{{ codigo.id }} - {{ codigo.descricao }}</option>
        </select>
      </div>
    </div>
  </div>
</section>

<app-new-modal-message #modalMessage [showFecharBtn]="false" [title]="'Atenção!'"></app-new-modal-message>
